import { createFileRoute } from "@tanstack/react-router";
import { ChartFilters } from "@/components/chart-filters";
import { DownloadsChart } from "@/components/charts/downloads";
import { DownloadsByPublisherChart } from "@/components/charts/downloads-by-publisher";
import { SectionCards } from "@/components/section-cards";
import { SiteHeader } from "@/components/site-header";
import { useChartFilters } from "@/hooks/use-chart-filters";
import { validateStatisticsSearch } from "@/lib/statistics";

export const Route = createFileRoute("/_app/")({
	component: Page,
	validateSearch: validateStatisticsSearch,
});

function Page() {
	const search = Route.useSearch();

	const chartFilters = useChartFilters({
		allStartDate: new Date("2025-01-01"),
		initialFilter: search.q,
		initialDate:
			search.from && search.to
				? { from: new Date(search.from), to: new Date(search.to) }
				: undefined,
	});

	return (
		<>
			<SiteHeader breadcrumbs={[{ key: "dashboard", label: "Dashboard" }]} />
			<div className="flex flex-1 flex-col">
				<div className="@container/main flex flex-1 flex-col gap-2">
					<div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
						<SectionCards />
						<div className="grid grid-cols-12 gap-6 px-4 lg:px-6">
							<div className="col-span-full">
								<ChartFilters hook={chartFilters} className="px-4 lg:px-6" />
							</div>
							<DownloadsChart hook={chartFilters} />
							<DownloadsByPublisherChart hook={chartFilters} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
